export default "__VITE_ASSET__Bq79WxOW__"